import { Link } from "react-router-dom";

const LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;

const inline = (text) => {
  const out = [];
  let last = 0;
  for (const m of text.matchAll(LINK_RE)) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const href = m[2];
    out.push(
      href.startsWith("/") ? (
        <Link key={m.index} to={href}>{m[1]}</Link>
      ) : (
        <a key={m.index} href={href} target="_blank" rel="noopener noreferrer">{m[1]}</a>
      )
    );
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
};

export const RichText = ({ text = "", className = "prose-lux" }) => (
  <div className={className}>
    {text.split(/\n\s*\n/).map((b, i) => {
      const t = b.trim();
      if (!t) return null;
      if (t.startsWith("### ")) return <h3 key={i}>{inline(t.slice(4))}</h3>;
      if (t.startsWith("## ")) return <h2 key={i}>{inline(t.slice(3))}</h2>;
      return <p key={i}>{inline(t)}</p>;
    })}
  </div>
);
